<template>
  <div class="background-display">
  <v-container fluid class="px-1">
    <Navbar />
      <v-card>
        <v-toolbar dark color="#00b2bb">
          <h2 class="ma-5 headline font-weight-thin">{{ titulo }}</h2>
        </v-toolbar>
        <v-card-text>
          <div class="text-center">
              <p><v-icon size="128">mdi-check</v-icon></p>
              <h1 class="headline mb-5">Pago Realizado con éxito</h1>
              <p class="title-size">En breves momentos recibirás a tu correo instrucciones para firmar y seguir proceso de autorización notarial.
              <br>Terminado el proceso llegará, desde Notaría Ronchera, un correo de notificación con documento finalizado.</p>
            </div>
            <v-row>
              <template>
              <v-row class="ma-5 justify-center" cols="12" xs="6" md="4" lg="4">
                <template >
                  <v-btn color="#00b2bb" dark @click="handleSubmit" style="margin-top: 40px;"
                  >Continuar</v-btn>
                </template>
              </v-row>
              </template>
            </v-row>
        </v-card-text>
      </v-card>
  </v-container>
  </div>
</template>
<style>
.title-size {
  font-size: 80%;
}
.background-display {
  background-color: dodgerblue;
  width: auto;
  min-height: 100%;
}
</style>
<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar.vue'
/* import cost1 from '@/mock/cost1.json' */

export default {
  name: 'Boleta',
  components: {
    Navbar
  },
  data () {
    return {
      titulo: 'Estatus de Trámite'
    }
  },
  methods: {
    handleSubmit () {
      this.$router.push(`/Ticket/${this.$route.params.id}`)
    }
  }
}
</script>
